// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"qs-z","giftOrPromoSelector":"rs-z","disabled":"ss-z","subTitle":"ts-z","selectShipAddressMessage":"us-z","changePayment":"vs-z"};